import { render, staticRenderFns } from "./ele-percent.vue?vue&type=template&id=31a8dfdb&scoped=true&"
import script from "./ele-percent.vue?vue&type=script&lang=js&"
export * from "./ele-percent.vue?vue&type=script&lang=js&"
import style0 from "./ele-percent.vue?vue&type=style&index=0&id=31a8dfdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8dfdb",
  null
  
)

export default component.exports